import { render, staticRenderFns } from "./VoucherBalance.vue?vue&type=template&id=76f724f0"
import script from "./VoucherBalance.vue?vue&type=script&lang=js"
export * from "./VoucherBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports